module.exports = __webpack_public_path__ + "static/media/graph-expand.a2c543c6.svg";